var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1502_65)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1502_65",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0H0V13H13V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1502_65)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.156556 2.19149C1.18748 2.87663 2.2102 3.56568 3.07348 4.45289C2.57863 6.56746 4.55365 8.25693 6.35489 9.25226C7.06004 9.64191 7.37171 9.91508 8.15669 9.78379L11.2481 12.7139C5.43038 14.6041 -1.09855 6.6741 0.156556 2.19149ZM8.95358 9.03041L9.63171 8.3641C9.82725 8.17165 10.1501 8.16922 10.349 8.35849L12.8492 10.7399C13.048 10.9291 13.0505 11.2415 12.855 11.4338L12.1766 12.1002C11.981 12.2925 11.6582 12.295 11.4592 12.1057L8.95905 9.72433C8.76013 9.53516 8.75772 9.22285 8.95358 9.03041ZM0.765902 0.789995L1.25802 0.21192C1.46897 -0.0358557 1.85129 -0.071615 2.10741 0.132467L4.66694 2.17234C4.92306 2.37663 4.9597 2.74628 4.74896 2.99438L4.25663 3.57213C4.04557 3.82023 3.66336 3.85567 3.40713 3.65159L0.84803 1.61172C0.591912 1.40764 0.55473 1.03777 0.765902 0.789995Z",
    fill: "#B99750"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1502_65"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconShare);
export default __webpack_public_path__ + "static/media/phone-icon-share.59c241966ff29cdac72f13685badd08b.svg";
export { ForwardRef as ReactComponent };